module.exports = __webpack_public_path__ + "static/media/joint_user.e2cdafa9.svg";